export const apiUrl = "https://api.xmldatafeed.com"
//export const apiUrl = "http://localhost:55784" // для тестов апишки


// WEBPACK FOOTER //
// ./src/config.js